import CompliancePolicyPage from 'screens/Contract/CompliancePolicy/CompliancePolicy';

export default CompliancePolicyPage;
